import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from "react";

type LeadDetailModalContextType = { 
  open: (leadId: string, initialTab?: string) => void; 
  close: () => void; 
  isOpen: boolean;
  isProviderReady: boolean;
  openedId: string | null;
  initialTab: string | null;
};

const defaultContextValue: LeadDetailModalContextType = {
  open: () => {},
  close: () => {},
  isOpen: false,
  isProviderReady: false,
  openedId: null,
  initialTab: null,
};

const LeadDetailModalContext = createContext<LeadDetailModalContextType>(defaultContextValue);

export function LeadDetailModalProvider({ children }: { children: ReactNode }) {
  const [openedId, setOpenedId] = useState<string | null>(null);
  const [initialTab, setInitialTab] = useState<string | null>(null);

  const open = useCallback((leadId: string, tab?: string) => {
    if (!leadId || leadId.trim() === '') return;
    console.log('🔓 [LeadDetailModal] Abrindo lead:', leadId, 'na aba:', tab || 'dados');
    setOpenedId(leadId);
    setInitialTab(tab || 'dados');
  }, []);
  
  const close = useCallback(() => { 
    console.log('🔒 [LeadDetailModal] Fechando modal');
    setOpenedId(null);
    setInitialTab(null);
  }, []);

  const value: LeadDetailModalContextType = useMemo(() => ({ 
    open, 
    close, 
    isOpen: !!openedId, 
    isProviderReady: true, 
    openedId,
    initialTab 
  }), [open, close, openedId, initialTab]);

  return (
    <LeadDetailModalContext.Provider value={value}>
      {children}
    </LeadDetailModalContext.Provider>
  );
}

export function useLeadDetailModal(): LeadDetailModalContextType {
  return useContext(LeadDetailModalContext);
}
